import { Box, Typography } from '@mui/material';

const HeaderWithBar = ({ text, barColor = 'green', barWidth = '50px' }) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      sx={{
        gap: '10px',
        marginBottom: '10px',
      }}
    >
      <Typography
        variant="body1"
        sx={{
          display: 'inline-block',
        }}
      >
        {text}
      </Typography>
      <Box
        sx={{
          height: '4px',
          width: "70px",
          borderRadius: '10px',
          backgroundColor: (theme)=>theme.palette.primary.main,
          marginTop: '4px',
        }}
      />
    </Box>
  );
};

export default HeaderWithBar;
